import { Action } from '@reduxjs/toolkit';
import { call, put, select } from 'redux-saga/effects';
import { FeatureFlag } from 'features/feature-set/types';
import { selectNotificationsByScope } from 'features/notifications/notificationsSlice';
import { closeActionNotifications } from 'features/notifications/thunks/closeActionNotifications';
import { NotificationId } from 'features/notifications/types';
import { qaCleared } from 'features/qa/qaSlice';

export function* clearQASaga() {
  const notificationIds: NotificationId[] = yield select(
    selectNotificationsByScope,
    FeatureFlag.qa
  );

  const cleanupNotificationsThunk: Action = yield call(closeActionNotifications, notificationIds);
  yield put(cleanupNotificationsThunk);

  yield put(qaCleared());
}
